var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadInspirationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E8E6FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0AF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.333 9.166 2.5-2.5m0 0 2.5 2.5m-2.5-2.5v5M15.417 7.5H11.5c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093C7.5 9.4 7.5 10.1 7.5 11.5v7c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.092c.535.273 1.235.273 2.635.273h7.667c.775 0 1.162 0 1.48-.085a2.5 2.5 0 0 0 1.768-1.768c.085-.318.085-.705.085-1.48m-8.75-7.084a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Zm3.742 2.849-7.05 6.408c-.396.36-.594.54-.612.697a.417.417 0 0 0 .14.36c.117.103.385.103.921.103h7.822c1.2 0 1.8 0 2.27-.202a2.5 2.5 0 0 0 1.316-1.315c.201-.47.201-1.07.201-2.27 0-.403 0-.605-.044-.793a1.667 1.667 0 0 0-.312-.648c-.119-.152-.276-.278-.591-.53l-2.332-1.865c-.315-.252-.473-.378-.646-.423a.834.834 0 0 0-.465.015c-.17.055-.32.191-.618.463Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadInspirationIcon);
export default __webpack_public_path__ + "static/media/upload-inspiration-icon.0e05897aa727ef5de399bd15fdfce4eb.svg";
export { ForwardRef as ReactComponent };